import { Component, OnDestroy, OnInit } from '@angular/core'
import { FilterOption, MpupFilter, Transaction } from '../../../types/mpup-types'
import { MpupTransactionsService } from '../../../services/mpup-transactions.service'
import { mergeMap, takeUntil } from 'rxjs/operators'
import { BehaviorSubject, combineLatest, Subject } from 'rxjs'
import { InitialPaginationModel } from '../../../services/mpup-pagination.service'

@Component({
  selector: 'mb-mpup-transactions-view',
  templateUrl: './mpup-transactions-view.component.html',
  styleUrls: ['./mpup-transactions-view.component.scss']
})
export class MpupTransactionsViewComponent implements OnInit, OnDestroy {

  listItems!: ReadonlyArray<Transaction>
  pagination =  new BehaviorSubject<InitialPaginationModel>({ pageSize: 2, currentPage: 0 })
  searchTerm = new BehaviorSubject('')
  filters: BehaviorSubject<Array<MpupFilter<Transaction>>> = new BehaviorSubject<Array<MpupFilter<Transaction>>>([])

  transactionTypes!: ReadonlyArray<FilterOption>
  private unsubscribe$ = new Subject<void>()

  constructor (private transactionsService: MpupTransactionsService) {
  }

  ngOnInit () {
    this.transactionsService
    .getTransactionTypes()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe({
      next: (value) => {
        this.transactionTypes = value
      }
    })

    this.getTransactions()
  }

  ngOnDestroy () {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  getTransactions () {
    combineLatest([this.searchTerm, this.filters])
      .pipe(takeUntil(this.unsubscribe$),
        mergeMap(([searchTerm, filters]) => (
          this.transactionsService.getTransactions(searchTerm, filters, this.pagination.value)))
      )
      .subscribe({
        next: (response) => {
          this.listItems = response.items
          this.pagination.next({ ...this.pagination.value, ...response.pagination })
        }
      })
  }

  changePage (page: number) {
    this.pagination.next({ ...this.pagination.value, currentPage: page })
    this.getTransactions()
  }

  searchTransactionsList (searchTerm: string): void {
    this.changePage(0)
    this.searchTerm.next(searchTerm)
  }

  filter (filterValue: string, filterField: keyof Transaction) {
    this.changePage(0)
    const otherFilters = this.filters.value.filter(entry => entry.filterField !== filterField)
    this.filters.next([...otherFilters, { filterValue, filterField }])
  }
}
